import { TyRoute } from 'typings/tyRoute';
import { ActionType } from '../action';
import { SET_ROUTES } from '../action/constants';

export default (state: TyRoute[] = [], action: ActionType): TyRoute[] => {
  let res: TyRoute[] = [...state];
  if (action.type === SET_ROUTES) {
    res = [
      ...state,
      ...action.routes,
    ];
  }
  return res;
};
